module.exports = __webpack_public_path__ + "img/39.6afb08ef.png";